import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import GenericEventList from "./GenericEventList";
import AddCalendarEventForm from "./AddCalendarEventForm";
import {
  createAwarenessThunk,
  deleteAwarenessDay,
  fetchProposedAwarenessThunk,
  fetchAwarenessThunk,
  deleteAwarenessThunk
} from "../redux/academicCalendarSlice";
import FlatEventListSelector from "./FlatEventListSelector";
import userStore from "../../../zustand/userStore";
import { useNavigate } from "react-router-dom";
import { setStepIndex, startTour } from "../../../redux/globalJoyrideSlice";
import { getAwarenessTourSteps } from "../../../tour/academicCalenderTourSteps";

export default function AwarenessCalendar({ onBackToCalendar,
  setTourStage,
  setActiveTab,
  setHolidaySubTab,
  setShowAddAwarenessForm,
  setAwarenessSubTab
}) {
  const navigate = useNavigate();
  const userData = userStore((state) => state.user);
  const dispatch = useDispatch();
  const master = useSelector((s) => s.academicCalendar.masterawarenessDays);
  const list = useSelector((s) => s.academicCalendar.awarenessDays);
  console.log("list:", list);

  const [subTab, setSubTab] = useState("select");
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  useEffect(() => {
    if (subTab === "select") {
      dispatch(fetchProposedAwarenessThunk({ user_id: userData.id }));
    } else if (subTab === "list") {
      dispatch(fetchAwarenessThunk({ user_id: userData.id }));
    }
  }, [subTab, dispatch]);

  const groupedAwareness = useMemo(() => {
    if (!master || !Array.isArray(master)) return {};

    return {
      "Awareness Days": master.map((item) => ({
        ...item,
        name: item.details,
      })),
    };
  }, [master]);
  const handleDeleteAwarenessDay = (id) => {
    if (window.confirm("Are you sure you want to delete this awareness day?")) {
      dispatch(deleteAwarenessThunk(id));
    }
  };

  return (
    <div className=" px-5">
      <div
        id="awareness-add-custom-anchor"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "1px",
          height: "1px",
          pointerEvents: "none",
        }}
      />
      <div className="d-flex mb-3">
        <button
          className={`btn me-2 ${subTab === "select" ? "btn-primary" : "btn-light"}`}
          data-tour="awareness-proposed-tab"
          onClick={() => {
            setSubTab("select");
            setShowForm(false);
            setEditItem(null);
            dispatch(setStepIndex(1))
          }}
        >
          Proposed Awareness Days
        </button>
        <button
          className={`btn me-2 ${subTab === "list" ? "btn-primary" : "btn-light"}`}
          data-tour="awareness-list"
          onClick={() => {
            setSubTab("list");
            setShowForm(false);
            setEditItem(null);
          }}
        >
          Awareness List
        </button>
        <button
          className={`btn ${subTab === "custom" ? "btn-primary" : "btn-light"}`}
          onClick={() => {
            console.log("clicked");
            setSubTab("custom");
            setShowForm(true);
            setEditItem(null);
          }}
        >
          Add Awareness Day
        </button>
        <button
          className="btn btn-primary ms-auto"
          onClick={onBackToCalendar}
        >
          Back
        </button>
      </div>

      {/* Select Awareness Days */}
      {subTab === "select" && (
        <div data-tour="awareness-select-list">
          <FlatEventListSelector
            title="Select Awareness Days"
            categories={groupedAwareness}
            alreadySubmittedIds={list.map(item => Number(item.awareness_id))} // cast to number for safe comparison
            onBulkSubmit={async (selected) => {
              try {
                for (const item of selected) {
                  const payload = {
                    school_id: 1,
                    user_id: userData.id,
                    start_date: item.start_date,
                    end_date: item.end_date,
                    details: item.name || item.details,
                    awareness_id: item.id
                  };
                  await dispatch(createAwarenessThunk(payload)).unwrap();
                }
                alert("Selected awareness days submitted successfully!");
                setSubTab("list");
                dispatch(
                  startTour({
                    tourName: "awareness",
                    steps: getAwarenessTourSteps({
                      dispatch,
                      setTourStage,
                      setActiveTab,
                      setHolidaySubTab,
                      setShowAddAwarenessForm:setShowForm,
                      setAwarenessSubTab:setSubTab
                    }),
                  })
                );
                
              } catch (err) {
                console.error("Submission failed:", err);
                alert("Failed to submit awareness days.");
              }
            }}
          />
        </div>
      )}

      {/* Awareness Day List */}
      {subTab === "list" && (
        <div data-tour="awareness-list">
          <GenericEventList
            itemType="awareness"
            title="Awareness Day"
            data={list}
            onEdit={(item) => {
              setEditItem({
                ...item,
                start_date: moment(item.start_date).format("YYYY-MM-DD"),
                end_date: moment(item.end_date).format("YYYY-MM-DD"),
              });
              setSubTab("custom");
              setShowForm(true);
            }}
            onDelete={handleDeleteAwarenessDay}
          />
        </div>
      )}

      {/* Add/Edit Form */}
      {(subTab === "custom" || showForm) && (
        <AddCalendarEventForm
          itemType="awareness"
          editItem={editItem}
          onClose={() => {
            setShowForm(false);
            setEditItem(null);
            setSubTab("list");
          }}
        />
      )}
    </div>
  );
}
